export default "__VITE_ASSET__D3GTB9jx__"